export const CONTENT_GROUPS = [
  { label: "Hero", prefixes: ["hero"] },
  { label: "Manifesto", prefixes: ["manifesto"] },
  { label: "Collections (Bento)", prefixes: ["collections"] },
  { label: "Collection Sections", prefixes: ["col"] },
  { label: "Signup", prefixes: ["signup"] },
  { label: "Footer", prefixes: ["footer"] },
  { label: "Social Links", prefixes: ["social"] },
  { label: "Navigation", prefixes: ["nav"] },
];

export const COLLECTIONS = ["originals", "faucet", "skate", "goods"];
export const COL_LABELS = {
  originals: "GG Originals",
  faucet: "Faucet Collective",
  skate: "Skate",
  goods: "Goods",
};

export const EMPTY = {
  name: "",
  collection: "originals",
  price: 0,
  description: "",
  sizesText: "S, M, L",
  imagesText: "",
  status: "coming_soon",
  featured: false,
  size_inventory: {},
  low_stock_threshold: 5,
  allow_backorder: false,
};

export const MEDIA_ASSETS = [
  { key: "media_hero", label: "Homepage Hero Background" },
  { key: "media_originals", label: "GG Originals — Section Header" },
  { key: "media_faucet", label: "Faucet Collective — Section Header" },
  { key: "media_skate", label: "Skate — Section Header" },
  { key: "media_goods", label: "Goods — Section Header" },
  { key: "bento_originals", label: "GG Originals — Four Corners Tile" },
  { key: "bento_faucet", label: "Faucet Collective — Four Corners Tile" },
  { key: "bento_skate", label: "Skate — Four Corners Tile" },
  { key: "bento_goods", label: "Goods — Four Corners Tile" },
];

export function prettyLabel(key) {
  return key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

export function isMultiline(key, val) {
  return /body|desc|blurb|heading/.test(key) || (val || "").length > 55 || (val || "").includes("\n");
}
